import {useParams} from "react-router-dom";
import {useModel} from "../../../hook/use_model";
import {StakeModel} from "../../../model/stake_model";
import React, {useCallback, useContext} from "react";
import {BackdropContext} from "../../../provider/backdrop_provider";
import {HttpServer} from "../../../net/http_server";
import {ModalContext} from "../../../provider/model_provider";
import {CircularProgress} from "@material-ui/core";
import {AppConfig} from "../../../config";
import {useSignFn} from "../../../utils/sign_fn";
import {useWallet} from "use-wallet";
import {SuccessWidget} from "../../personal/arbitration/success_widget";

export const useChallenge = (id:string,cover_hash:string) => {

    const {onPresent, onDismiss} = useContext(ModalContext);
    const handleChallengeP = useChallengeP(id, cover_hash)
    const handleChallenge = useCallback(async () => {
        onPresent(<CircularProgress color="primary"/>);
        try {
            let _data = await HttpServer.challenge(id);
            onPresent(<StakeModel handleChallenge={handleChallengeP} success={SuccessWidget} amount={_data}/>);
        } catch (e) {
            onDismiss();
        }


    }, [handleChallengeP]);


    return handleChallenge;
}

export const useChallengeP = (claim_id: string, coverHash: string) => {
    const sign = useSignFn();
    const {account} = useWallet();
    const fatch = useCallback(async ()=>{
        let _params = claimAppleJson(claim_id, coverHash,account);
        let _hex = await sign(_params);
        let _data = HttpServer.challengeP(_hex,_params);
        return _data;
    },[claim_id, coverHash,account]);

    return fatch;
}

const claimAppleJson = (claim_id: string, cover_hash: string,account:string|null): string => {
    let method = "claim_challenge";

    return JSON.stringify({
        domain: {
            name: method,
            chainId: AppConfig.chainId.toString(),
        },
        message: {
            method: method,
            content: {
                user_id: account,
                claim_id: parseInt(claim_id),
                cover_hash: cover_hash,
            }
        },
        primaryType: 'Place',
        types: {
            EIP712Domain: [
                {name: 'name', type: 'string'},
                {name: 'chainId', type: 'uint256'},
            ],
            Place: [
                {name: 'content', type: 'Model'},
                {name: 'method', type: 'string'},
            ],
            Model: [
                {name: 'user_id', type: 'string'},
                {name: 'claim_id', type: 'uint256'},
                {name: 'cover_hash', type: 'string'},
            ],

        }
    });
}
